import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, throwError, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PharmacyAutoCompleteResponse } from '../../pages/admin-dashboard/account-statement/account-statement-auto-complete/account-statement-auto-complete.model';
import { PharmacyAutoCompleteParams } from '../../pages/admin-dashboard/cart-management/admin-cart.model';
import { AuthService } from '../auth-service';

@Injectable({
  providedIn: 'root',
})
export class AccountAutoComplete {
  private http = inject(HttpClient);
  private authService = inject(AuthService);

  private readonly API = environment.pharmacyMgtApiUrl;
  private readonly AUTO_COMPLETE_ENDPOINT = `${this.API}/pharmacies/auto/complete`;

  private getAuthHeaders(): HttpHeaders {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  private buildAutoCompleteParams(queryParams: PharmacyAutoCompleteParams): HttpParams {
    let params = new HttpParams();

    if (queryParams.quickSearch) {
      params = params.set('quickSearch', queryParams.quickSearch);
    }
    if (queryParams.isApproved !== undefined) {
      params = params.set('isApproved', queryParams.isApproved.toString());
    }

    params = params.set('pageNum', (queryParams.pageNum ?? 0).toString());
    params = params.set('pageSize', (queryParams.pageSize ?? 25).toString());

    return params;
  }

  getAutoCompletePharmacies(queryParams: PharmacyAutoCompleteParams): Observable<PharmacyAutoCompleteResponse> {
    const headers = this.getAuthHeaders();
    const params = this.buildAutoCompleteParams(queryParams);

    return this.http.get<PharmacyAutoCompleteResponse>(this.AUTO_COMPLETE_ENDPOINT, { params, headers }).pipe(
      tap((response) => console.log(`Retrieved ${response.list?.length ?? 0} pharmacies`)),
      catchError(this.handleError),
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    return throwError(() => error.error);
  }
}
